<svg
  [ngStyle]="styleList"
  [attr.width]="size"
  [attr.height]="size"
  viewBox="0 0 64 64"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect
    x="1.5"
    y="1.5"
    width="61"
    height="61"
    [attr.rx]="rx"
    fill="url(#paint0_linear_103_2177)"
    stroke="#FEFEFE"
    stroke-width="3"
  />
  <path
    d="M50.5 32C50.5 42.2173 42.2173 50.5 32 50.5C21.7827 50.5 13.5 42.2173 13.5 32C13.5 21.7827 21.7827 13.5 32 13.5C42.2173 13.5 50.5 21.7827 50.5 32Z"
    fill="url(#paint1_linear_103_2177)"
    stroke="url(#paint2_linear_103_2177)"
  />
  <path
    opacity="0.78"
    d="M32 51.5C42.7696 51.5 51.5 42.7696 51.5 32C51.5 21.2304 42.7696 12.5 32 12.5C21.2304 12.5 12.5 21.2304 12.5 32C12.5 42.7696 21.2304 51.5 32 51.5Z"
    stroke="url(#paint3_radial_103_2177)"
  />
  <mask
    id="mask0_103_2177"
    style="mask-type: alpha"
    maskUnits="userSpaceOnUse"
    x="13"
    y="13"
    width="38"
    height="38"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 51C42.4934 51 51 42.4934 51 32C51 21.5066 42.4934 13 32 13C21.5066 13 13 21.5066 13 32C13 42.4934 21.5066 51 32 51Z"
      fill="url(#paint4_linear_103_2177)"
    />
  </mask>
  <g mask="url(#mask0_103_2177)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M56.1021 18.1403L31.6 42.2049L19.8979 30.7117L24.1021 26.431L31.6 33.795L51.8979 13.8596L56.1021 18.1403Z"
      fill="white"
    />
  </g>
  <defs>
    <linearGradient
      id="paint0_linear_103_2177"
      x1="37.5"
      y1="64.0004"
      x2="-64.6232"
      y2="47.3419"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="#EBECF7"
      />
    </linearGradient>
    <linearGradient
      id="paint1_linear_103_2177"
      x1="32"
      y1="13"
      x2="-15.2756"
      y2="31.4327"
      gradientUnits="userSpaceOnUse"
    >
      <stop />
      <stop
        offset="1"
        stop-color="white"
      />
    </linearGradient>
    <linearGradient
      id="paint2_linear_103_2177"
      x1="44.5735"
      y1="10.0769"
      x2="24.9569"
      y2="28.236"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        stop-color="white"
        stop-opacity="0"
      />
      <stop
        offset="0.428115"
        stop-color="white"
        stop-opacity="0.81428"
      />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </linearGradient>
    <radialGradient
      id="paint3_radial_103_2177"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(13 14) rotate(60.141) scale(31.1328)"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0"
      />
    </radialGradient>
    <linearGradient
      id="paint4_linear_103_2177"
      x1="23.4828"
      y1="31.7476"
      x2="53.8187"
      y2="33.937"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="white" />
      <stop
        offset="1"
        stop-color="white"
        stop-opacity="0.49"
      />
    </linearGradient>
  </defs>
</svg>
